import { CategoryFilterItem } from "projects/shared/lib/components/shared/category/filter/item/category-filter-item.model";

export class SearchState {
  public searchTerm: string | undefined;
  public categoryFilterEntryList: CategoryFilterItem[] | undefined;
}
